// extracted by mini-css-extract-plugin
module.exports = {"title":"Register_title__3HoB3","buttons":"Register_buttons__2qXgB"};